import React, { useState, useMemo } from 'react'
import Select from 'react-select'
import countryList from 'react-select-country-list'

import contact_bg from '../../assets/contact_bg.png'
import contact_man from '../../assets/contact_man.png'
import project_bg from '../../assets/ww.png'

const Contact = () => {
	const [firstName, setFirstName] = useState('')
	const [lastName, setLastName] = useState('')
	const [email, setEmail] = useState('')
	const [country, setCountry] = useState('')
	const [description, setDescription] = useState('')

	const options = useMemo(() => countryList().getData(), [])

	const changeHandler = (value) => {
		setCountry(value)
	}

	return (
		<main className='contact_page'>
			<section
				className='about_jumbo jumbo_section'
				style={{ background: `url(${contact_bg})` }}
			>
				<div className='container'>
					<div className='d-flex about_jumbo_text'>
						<div>
							<h1>Contact</h1>
						</div>
					</div>
				</div>
			</section>

			<section className='' style={{ background: `url(${project_bg})` }}>
				<div className='container'>
					<div className='row justify-content-center'>
						<div className='col-md-11'>
							<div className='text-center'>
								<h2>Fill in your details </h2>
								<h6>We will contact you shortly!</h6>
							</div>

							<div className='pb-5'>
								<div className='row no-gutters pb-5'>
									<div className='col-lg-5 col-md-12'>
										<img
											src={contact_man}
											className='contact_form_image'
											alt=''
										/>
									</div>
									<div className='col-lg-7 col-md-12'>
										<div className='contact_page_form'>
											<form>
												<div className='row'>
													<div className='col-md-6'>
														<label htmlFor='first name'>First Name</label>
														<input
															type='text'
															className='form-control'
															onChange={(e) => setFirstName(e.target.value)}
														/>
													</div>
													<div className='col-md-6'>
														<label htmlFor='first name'>Last Name</label>
														<input
															type='text'
															className='form-control'
															onChange={(e) => setLastName(e.target.value)}
														/>
													</div>
													<div className='col-md-12'>
														<label htmlFor='first name'>Email</label>
														<input
															type='email'
															className='form-control'
															onChange={(e) => setEmail(e.target.value)}
														/>
													</div>
													<div className='col-md-12'>
														<label htmlFor='first name'>Select Country</label>
														<Select
															options={options}
															value={country}
															onChange={changeHandler}
														/>
													</div>
													<div className='col-md-12'>
														<label htmlFor=''>Description</label>
														<textarea
															className='form-control'
															id=''
															cols='30'
															rows='5'
															onChange={(e) => setDescription(e.target.value)}
														></textarea>
													</div>
												</div>
												<div className='text-center'>
													<button type='submit' className='btn contact_btn'>
														Submit
													</button>
												</div>
											</form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</main>
	)
}

export default Contact
